import { FunctionComponent, useEffect, useState } from "react";
import { Input, Col, Select, Button, Divider } from "antd"
import { DeleteOutlined } from '@ant-design/icons';

interface FilterInputProps {
    filterInput: { field: string, operator: string, value: string },
    index: number,
    filterableFields: Array<string>,
    filtersCount: number,
    onFilterFieldChange: (value) => void,
    onFilterOperatorChange: (value) => void,
    onFilterValueChange: (value) => void,
    onCloseClick: () => void,
    fieldLabels?: object,
    accounts?: Array<string>
    statusTypes?: Array<string>
}

function SelectBox({ object, filterInput, onFilterValueChange, index }) {
    return <Select
        key={filterInput.field + index}
        style={{ width: '100%', minWidth: '210px' }}
        getPopupContainer={trigger => trigger.parentNode}
        value={filterInput.value}
        onChange={(value) => {
            onFilterValueChange(value)
        }}
        showSearch
        filterOption={(value: any, option: any) => option?.children?.toLowerCase()?.includes(value?.toLowerCase())}
    >
        {
            Array.isArray(object) ? object.map((item) => {
                var itemData: any = {}
                if (item.label && item.value) {
                    itemData = item;
                }
                else if (typeof item === "string") {
                    itemData.key = item;
                    itemData.label = item;
                    itemData.value = item;
                }
                else {
                    itemData.key = item?.uid;
                    itemData.label = item?.name;
                    itemData.value = item?.name;
                }
                return <Select.Option key={itemData.key} value={itemData.value}>
                    {itemData?.label}
                </Select.Option>
            })
                : Object.keys(object).map(key => {
                    return <Select.Option key={key} value={key} >
                        {object[key]}
                    </Select.Option>
                })
        }
    </Select>
}

const FilterInput: FunctionComponent<FilterInputProps> = (props: FilterInputProps) => {
    const { index, filterInput, filterableFields, filtersCount, accounts, statusTypes, onFilterFieldChange, onFilterOperatorChange, onFilterValueChange, onCloseClick, fieldLabels } = props;
    const [fieldName, setFieldName] = useState(filterInput.field);
    const dropDownFields = ["account_name", "status"];
    const isFieldNameSelected = fieldName ? true : false

    useEffect(() => {
        setFieldName(filterInput.field)
        if (filterInput.field === "") {
            setFieldName("")
        }
    }, [filterInput])

    return (<Input.Group key={index}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gridGap: '10px', marginBottom: '20px' }}>
            <div style={{ width: '30%', minWidth: '210px' }} className="advanced-filters-field">
                <Select
                    style={{ width: "100%", minWidth: '210px' }}
                    value={filterInput.field}
                    defaultActiveFirstOption={false}
                    filterOption={true}
                    onChange={(value) => {
                        setFieldName(value);
                        onFilterFieldChange(value);
                        onFilterValueChange("");
                        if (dropDownFields.includes(value)) {
                            onFilterOperatorChange("equals");
                        }
                    }}
                    notFoundContent={null}
                >
                    {filterableFields?.map((d) => {
                        return <Select.Option key={d} value={d}>
                            {fieldLabels?.[d]}
                        </Select.Option>
                    })}
                </Select>
            </div>
            <div style={{ width: '20%', minWidth: '150px' }}>
                {
                    dropDownFields.includes(fieldName)
                        ? <Input style={{ width: "100%", minWidth: '150px', maxWidth: '210px' }} value={"Equals"} readOnly />
                        : <Select style={{ width: "100%", minWidth: '150px', maxWidth: '210px' }} value={filterInput.operator}
                            onChange={(value) => {
                                onFilterOperatorChange(value);
                            }}
                        >
                            {["equals", "contains"].map(field => (
                                <Select.Option key={field} value={field}>
                                    {{
                                        "equals": "Equals",
                                        "contains": "Contains"
                                    }?.[field] ?? field}
                                </Select.Option>
                            ))}
                        </Select>
                }
            </div>
            <div style={{ display: 'flex', gridGap: '10px', alignItems: 'center', width: '40%', maxWidth: '100%', minWidth: '210px' }}>
                {(() => {
                    switch (fieldName) {
                        case "account_name":
                            return <SelectBox object={accounts} filterInput={filterInput} onFilterValueChange={onFilterValueChange} index={index} />
                        case "status":
                            return <SelectBox object={statusTypes} filterInput={filterInput} onFilterValueChange={onFilterValueChange} index={index} />
                        default:
                            return <Input
                                readOnly={!isFieldNameSelected}
                                value={filterInput.value}
                                style={{ minWidth: '210px', width: '100%' }}
                                onChange={(event) => {
                                    onFilterValueChange(
                                        event.target.value
                                    );
                                }}
                            />
                    }
                })()
                }
                {
                    filtersCount > 1 &&
                    <Col span={2}>
                        <Button icon={<DeleteOutlined />}
                            onClick={onCloseClick}
                        >
                        </Button>
                    </Col>
                }
            </div>
            {
                filtersCount > 1 && (index + 1 !== filtersCount) &&
                <Divider style={{ borderTop: '1px solid #d7d7dc' }} className='show-in-mobile' />
            }
        </div>
    </Input.Group >);
}

export default FilterInput;
